import { Pipe, PipeTransform } from '@angular/core'

@Pipe({ name: 'conversationTypeLabel', standalone: true, pure: true })
export class ConversationTypeLabelPipe implements PipeTransform {
	transform(type: ChatConversationType): string {
		return type === 'BROADCAST' ? 'Broadcast' : 'Direct'
	}
}
